import { NoContentType } from './types/NoContentType.enum';
import { useStyles } from './noContentSelected.style';

import { Button, Typography } from '@material-ui/core';

interface NoContentSelectedProps {
  type: NoContentType;
}

const baseContent = {
  descriptionPrefix:
    'Go to edit mode and click on the gear icon of this widget to',
  buttonText: 'Open edit mode',
};

const contentOverrides: Readonly<
  Record<
    NoContentType,
    { readonly title: string; readonly descriptionAction: string }
  >
> = {
  [NoContentType.Team]: {
    title: 'No team selected.',
    descriptionAction: 'select the desired team.',
  },
  [NoContentType.Link]: {
    title: 'No links added.',
    descriptionAction: 'add new links.',
  },
};

function NoContentSelected({ type }: NoContentSelectedProps) {
  const { cx, classes } = useStyles();
  const { title, descriptionAction } = contentOverrides[type];
  const description = `${baseContent.descriptionPrefix} ${descriptionAction}`;

  return (
    <section className={cx(classes.noContentSelected)}>
      <Typography variant="body2">{title}</Typography>
      <Typography variant="body2">{description}</Typography>
      <Button variant="contained" color="primary" className="go-to-edit-mode">
        {baseContent.buttonText}
      </Button>
    </section>
  );
}

export { NoContentSelected };
